import { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { Popover, Transition } from "@headlessui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import countryCode from "../../countryCode/index.json"

export default function ChangeLanguage(props) {
    const [dropIcon, setDropIcon] = useState(false);

    const ArrowUp = () => {
        return <ChevronUpIcon className="h-5 w-5 text-[#F8BC04]" aria-hidden="true" />;
    };
    const ArrowDown = () => {
        return (
            <ChevronDownIcon className="h-5 w-5 text-[#F8BC04]" aria-hidden="true" />
        );
    };

    const languages = [
        {
            value: "en",
            icon: "united kingdom"
        },
        {
            value: "de",
            icon: "germany"
        },
    ]

    return (
        <Popover className="relative">
            <Popover.Button className="inline-flex items-center gap-x-1 text-sm font-semibold leading-6 text-gray-900">
                <span
                    className={`text-[16px] capitalize font-sans font-medium text-[white] ${props.titleStyle} flex space-x-3`}
                >
                    <img src={`https://flagcdn.com/w40/${countryCode[props?.title?.icon]}.png`} srcSet={`https://flagcdn.com/w80/${countryCode[props?.title?.icon]}.png 2x`} className="w-[40px] h-[20px] bg-white" />
                    <p>{props?.title?.value?.toUpperCase()}</p>
                </span>
                {dropIcon === false ? <ArrowDown /> : <ArrowUp />}
            </Popover.Button>
            <Transition
                beforeLeave={() => setDropIcon(false)}
                beforeEnter={() => setDropIcon(true)}
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"

            >
                <Popover.Panel className="absolute left-[70px] xl:left-1/2 z-10 mt-5 flex  max-w-min -translate-x-1/2 px-4">
                    <div className="w-36  shrink rounded-xl bg-white p-3 text-sm font-semibold leading-6 text-gray-900 ring-1 ring-gray-900/5 ">
                        {languages.map((item, index) => (
                            <div key={index}>
                                <div className="flex items-center cursor-pointer hover:text-darkYellow space-x-2" onClick={() => props.handleLanguageChange(item)}>
                                    <img
                                        className="w-[40px] h-[20px]"
                                        src={`https://flagcdn.com/w40/${countryCode[item.icon]}.png`}
                                        srcSet={`https://flagcdn.com/w80/${countryCode[item.icon]}.png 2x`}
                                        alt="flag"
                                    />
                                    <div
                                        key={item.value}
                                        className="block p-2  text-[15px] font-sans font-medium"

                                    >
                                        {item.value.toUpperCase()}
                                    </div>
                                </div>
                                {languages.length - 1 === index ? (
                                    <></>
                                ) : (
                                    <div className="w-full h-[1px] bg-[#DDDDDD]"></div>
                                )}
                            </div>
                        ))}
                    </div>
                </Popover.Panel>
            </Transition>
        </Popover>
    );
}
